import React from 'react'

function Welcome() {
  return (
    <section className="gunstars__welcome">
      <h1 className="gunstars__guns-title uppercase text-center mb-32">bem-vindo ao gunstars</h1>
      <p className="gunstars__guns-descriptions text-center" style={{ maxWidth: '975px' }}>Lute, explore e crie a melhor estratégia para sobreviver a batalhas épicas com até 36 jogadores. Jogabilidade inovadora que combina uma rápida curva de aprendizagem com um alto nível de habilidade que um grande jogo de tiro merece.</p>
    </section>
  )
}

export default Welcome;
